import React from 'react'
import { Box } from '@mui/material'

interface ProgressDotProps {
  size: number
  color: string
}

/**
 * Circle dot component
 * memoized for better performance in progress bar
 */
const ProgressDot: React.FC<ProgressDotProps> = ({ size, color }) => {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: color,
        transition: 'background-color 0.6s cubic-bezier(0.25, 1, 0.5, 1)',
      }}
    />
  )
}

ProgressDot.displayName = 'ProgressDot'

export default React.memo(ProgressDot)
